import { createAsyncThunk } from '@reduxjs/toolkit';
import { ax } from 'services/apiService';
// api/datahub_report/template_manager

export const getAllNotificationCenter = createAsyncThunk('get-notificationcenter-all', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`datahub_report/get_notifications_center`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const getNotificationCenterDetail = createAsyncThunk('get-notificationcenter-detail', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`datahub_report/get_notifications_center/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// datahub_report/add_template_manager
export const addNotificationCenter = createAsyncThunk('add-notification-center', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`datahub_report/add_notifications_center`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// datahub_report/remove_template_manager
export const removeNotificationCenter = createAsyncThunk('remove-notification-center', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.delete(`datahub_report/remove_notifications_center/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});